import { getSidepanelTabNavigationContext } from './sidepanel-tab-navigation-context';
import { TabId } from './sidepanel-types';

/**
 * Reusable hook for navigating to Statistics tab.
 * Can be used in any tab component within a device layout.
 *
 * @returns Object with navigateToHistoryStatisticsTab function
 */
export const useNavigateToHistoryStatisticsTab = () => {
	const context = getSidepanelTabNavigationContext();

	if (!context) {
		console.warn(
			'useNavigateToHistoryStatisticsTab: Navigation context not found. Make sure the component is within a device layout that provides the context.',
		);
		return {
			navigateToHistoryStatisticsTab: () => {
				console.warn('Navigation context not available');
			},
		};
	}

	const navigateToHistoryStatisticsTab = () => {
		const statisticsTabIndex = context.getTabIndex(TabId.STATISTICS);
		if (statisticsTabIndex >= 0) {
			context.navigateToTab(TabId.STATISTICS);
			return;
		}
		console.warn('Statistics tab not found in tabs configuration');
	};

	return { navigateToHistoryStatisticsTab };
};
